export const isDisabled = (toPresent: boolean, index: number) => {
  return toPresent;
};
